import { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import FilterPlate from '..';
import { FILTER_CLAUSE } from '../constants';
import CheckboxGroup from '../../CheckboxGroup';
import { useFilter } from 'src/hooks/filters/useFilter';

const FilterPlateCEnum = (props) => {
	const {
		enums,
		initialSelected,
		operator = FILTER_CLAUSE.contains,
		onSubmit,
		...rest
	} = props;

	const options = useMemo(() => {
		return [
			{ label: 'Равно', value: FILTER_CLAUSE.eq },
			{ label: 'Не равно', value: FILTER_CLAUSE.notEq },
			{ label: 'Пусто', value: FILTER_CLAUSE.null },
			{ label: 'Не пусто', value: FILTER_CLAUSE.notNull },
		];
	}, []);

	const {
		handleOptionChange,
		handleSubmit,
		handleValueChange,
		selectedOption,
		selectedValue,
	} = useFilter(options, initialSelected, operator, onSubmit, 'enum');

	const checksValue = useMemo(() => {
		if (Array.isArray(selectedValue)) {
			return selectedValue.map(String);
		}

		if (selectedValue === '' || selectedValue == null) {
			return [];
		}

		return [String(selectedValue)];
	}, [selectedValue]);

	const handleChecksChange = useCallback(
		(event) => {
			const optionValue = String(event.target.value);
			const { checked } = event.target;

			handleValueChange(
				event,
				checked
					? checksValue.includes(optionValue)
						? checksValue
						: [...checksValue, optionValue]
					: checksValue.filter((item) => item !== optionValue),
			);
		},
		[checksValue, handleValueChange],
	);

	let uiNode;
	switch (selectedOption?.value) {
		case FILTER_CLAUSE.eq:
		case FILTER_CLAUSE.notEq:
			uiNode = (
				<>
					<Box sx={{ pt: 1, pb: 0 }}>
						<Divider />
					</Box>
					<CheckboxGroup
						value={checksValue}
						options={enums}
						onChange={handleChecksChange}
					/>
				</>
			);
			break;
		case FILTER_CLAUSE.notNull:
			break;
		default:
			uiNode = null;
	}

	return (
		<FilterPlate
			typeSelector={{
				value: selectedOption,
				selectOnly: true,
				disableClearable: true,
				onChange: handleOptionChange,
				options,
			}}
			uiNode={uiNode}
			onSubmit={handleSubmit}
			{...rest}
		/>
	);
};

FilterPlateCEnum.propTypes = {
	...FilterPlate.propTypes,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	operator: PropTypes.string,
	enums: PropTypes.arrayOf(
		PropTypes.shape({
			value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
			label: PropTypes.string,
		}),
	),
	initialSelected: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number,
		PropTypes.arrayOf(
			PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
		),
	]),
};

export default FilterPlateCEnum;
